export const ANALYSIS_STATUS_SOURCES = {
  projectExtraField: 'project-extra-field',
  unavailable: 'unavailable',
};

export function createUnavailableAnalysisStatus(overrides = {}) {
  return {
    scope: 'project',
    awaitingClonalitySampleCount: null,
    source: ANALYSIS_STATUS_SOURCES.unavailable,
    isLoading: false,
    isError: false,
    errorMessage: null,
    ...overrides,
  };
}

function normalizeNullableCount(value) {
  return typeof value === 'number' && Number.isFinite(value) ? value : null;
}

function getResponseAttributes(response) {
  if (!response) {
    return null;
  }

  if (response.data?.attributes) {
    return response.data.attributes;
  }

  if (response.attributes) {
    return response.attributes;
  }

  if (response.lib_seqs_awaiting_clonality_analysis !== undefined) {
    return response;
  }

  return null;
}

export function normalizeProjectAnalysisStatusResponse(response, overrides = {}) {
  const attributes = getResponseAttributes(response);

  if (!attributes) {
    return createUnavailableAnalysisStatus(overrides);
  }

  return {
    ...createUnavailableAnalysisStatus(),
    scope: attributes.scope || 'project',
    awaitingClonalitySampleCount: normalizeNullableCount(attributes.lib_seqs_awaiting_clonality_analysis),
    source: ANALYSIS_STATUS_SOURCES.projectExtraField,
    isLoading: false,
    isError: false,
    errorMessage: null,
    ...overrides,
  };
}

export function getSampleDisplayState({
  primaryAnalysisStatus,
} = {}) {
  if (!primaryAnalysisStatus) {
    return {
      key: 'awaiting_analysis',
      label: 'Awaiting analysis',
      color: '#ff9800',
      isClickable: false,
    };
  }

  if (primaryAnalysisStatus === 'succeeded') {
    return {
      key: 'analysis_ready',
      label: 'Results ready',
      color: 'green',
      isClickable: true,
    };
  }

  if (primaryAnalysisStatus === 'failed') {
    return {
      key: 'analysis_failed',
      label: 'Analysis failed',
      color: 'red',
      isClickable: false,
    };
  }

  if (primaryAnalysisStatus === 'delayed') {
    return {
      key: 'analysis_delayed',
      label: 'Results delayed',
      color: '#ff9800',
      isClickable: false,
    };
  }

  return {
    key: 'analysis_running',
    label: 'Analyzing',
    color: '#0081ff',
    isClickable: false,
  };
}
